import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { UserSetting } from '@thiememeulenhoff/types';

export const userSettings = createStore(
  { name: 'userSettings' },
  withEntities<UserSetting, 'key'>({
    idKey: 'key',
  }),
);
